import { KnmWebNotificationStatusesEnum } from 'APIPackage/KnmModule/enums/KnmWebNotificationStatusesEnum';

export const mapWebNotificationStatusByBooleanStatus: Record<KnmWebNotificationStatusesEnum, boolean> = {
  [KnmWebNotificationStatusesEnum.CREATE]: false,
  [KnmWebNotificationStatusesEnum.REGISTERED]: false,
  [KnmWebNotificationStatusesEnum.WAITING_FOR_APPROVE]: false,
  [KnmWebNotificationStatusesEnum.APPROVED]: true,
  [KnmWebNotificationStatusesEnum.REJECTED]: true,
  [KnmWebNotificationStatusesEnum.REVIEWED_WITH_COMMENTS]: true,
};
